const body = document.querySelector('body');
const nav = document.querySelector('.header__menu');
const navIcons = document.querySelectorAll('.header__icons a');
const navDetails = document.querySelectorAll('.header__menu details summary');

navDetails.forEach(link => {
  link.addEventListener('focus', function() {
    navDetails.forEach(el =>  {

      body.classList.remove('has-dropdown-menu');
      
      el.removeAttribute('open');
      el.parentElement.removeAttribute('open');
      el.nextElementSibling.removeAttribute('open');

      if (el.nextElementSibling.classList.contains('dropdown')) {
        el.nextElementSibling.style.opacity = '0';
        el.nextElementSibling.style.visibility = 'hidden';
        el.nextElementSibling.firstElementChild.style.transform = 'translateY(-105%)';
      }
    });

    body.classList.add('has-dropdown-menu');
    
    this.setAttribute('open', 'true');
    if (this.parentElement) {
      this.parentElement.setAttribute('open', 'true');
    }
    if (this.nextElementSibling) {
      this.nextElementSibling.setAttribute('open', 'true');
    }

    if (this.nextElementSibling.classList.contains('dropdown')) {
      this.nextElementSibling.style.opacity = '1';
      this.nextElementSibling.style.visibility = 'visible';
      this.nextElementSibling.firstElementChild.style.transform = 'translateY(0)';
    }
  });

  // link.addEventListener('blur', function() {
  //   link.removeAttribute('open');
  //   link.parentElement.removeAttribute('open');
  //   link.nextElementSibling.removeAttribute('open');

  //   if (link.nextElementSibling.classList.contains('dropdown')) {
  //     link.nextElementSibling.style.opacity = '0';
  //     link.nextElementSibling.style.visibility = 'hidden';
  //     link.nextElementSibling.firstElementChild.style.transform = 'translateY(-105%)';
  //   }
  // });
});

navIcons.forEach(link => {
  link.addEventListener('focus', function() {
    navDetails.forEach(el =>  {

      body.classList.remove('has-dropdown-menu');
      
      el.removeAttribute('open');
      el.parentElement.removeAttribute('open');
      el.nextElementSibling.removeAttribute('open');

      if (el.nextElementSibling.classList.contains('dropdown')) {
        el.nextElementSibling.style.opacity = '0';
        el.nextElementSibling.style.visibility = 'hidden';
        el.nextElementSibling.firstElementChild.style.transform = 'translateY(-105%)';
      }
    });


  });  
});
